import SectionStructure from '../../../../components/Section/SectionStructure';
import Grid from '@mui/material/Grid';
import GeneticsCvdText from './GeneticsCvdText';
import CvdButtonGroup from './CvdButtonGroup'
import Obesity from './GeneticsCards/Obesity/Obesity'
import Hypertension from './GeneticsCards/Hypertension/Hypertension';
import Diabetes from './GeneticsCards/Diabetes/Diabetes';
import Cholesterol from './GeneticsCards/Cholesterol/Cholesterol';
import Heart from './GeneticsCards/HEART/Heart'
import Atherogenesis from './GeneticsCards/Atherogenesis/Atherogenesis';


export default function SectionGeneticsCvd() {

    
    return (

        <SectionStructure
    
        sectiontext=    { <GeneticsCvdText /> }
        sectiondiagroup=    { <CvdButtonGroup />} 

        sectioncards=  {<>

            <Grid container>
                    <Grid > <Obesity />         </Grid>
                    <Grid > <Hypertension />    </Grid>
                    <Grid>  <Diabetes />         </Grid>
                    <Grid>  <Cholesterol />      </Grid>
                    <Grid>  <Heart />            </Grid>
                    <Grid>  <Atherogenesis />   </Grid>
            </Grid>
        </>}
    />
    )}